import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import * as constans from "../const/constants";
import routes from "../assets/apiRoutes.json"
import SelectBox from 'devextreme-react/select-box';
import { LoadPanel } from 'devextreme-react/load-panel';
import axios from "axios";
const LoadIframe = (props) => {
    var oidc = props.oidc;
    var accessToken = props.oidc.user.access_token;
    var userName = props.oidc.user.profile.name;
    var webUserInfo = props.oidc.user.profile.webUserInfo;
    const parsedData = JSON.parse(webUserInfo);
    const userCompanyId = parsedData.userCompanyId;
    const { reportType } = useParams();
    const [source, setSource] = useState('');
    const [warehouse, setWarehouse] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState();
    const [warehouseLoadFailed, setWarehouseLoadFailed] = useState(false);
    const [frameLoading, setFrameLoading] = useState(false);
    const GetPageUrl = () =>{
        if (reportType == constans.EarlyTagReport) {
            return "/PTR/EarlyTagReport";
        }else if (reportType == constans.DashboardManagement) {
            return "/HOME/Index";
        }else if (reportType == constans.PTRDailyUpdates) {
            return "/PTR/DailyUpdates";
        }else if (reportType == constans.PTRDailyUpdates2) {
            return "/PTR/DailyUpdates2";
        }else if (reportType == constans.PTRConfiguration) {
            return "/PTR/Configuration";
        }else if (reportType == constans.PTROverrides) {
            return "/PTR/Overrides";
        }else if (reportType == constans.PTRAttributes) {
            return "/PTR/Attributes";
        }else if (reportType == constans.PTRRules) {
            return "/PTR/Rules";
        }else if (reportType == constans.PTRCropRollTool) {
            return "/PTR/CropRollTool";
        }
    }
    const buildPtrUrl = (warehouseId) => {
        // access_token: PTR needs the user's token to look up the company's database on the IDP.
        return `${window._env_.PTR_Base_URL}${GetPageUrl()}?warehouseRowId=${encodeURIComponent(warehouseId)}&userName=${encodeURIComponent(userName)}&userCompanyId=${encodeURIComponent(userCompanyId)}&access_token=${encodeURIComponent(accessToken)}`;
    };
    const fetchWareHouseList = async () => {
        try {
            const url = `${window._env_.REACT_APP_APIS}/${routes.PTR.GetWarehouselist}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error('Failed to fetch schedule data');
            }
            const result = await response.json();
            setWarehouse(result.data);
            // Keep a warehouse already picked on this visit: the profile's claim is only refreshed with the next token.
            var wh = props.oidc.user.profile?.warehouse;
            if (wh) {
                setSelectedWarehouse(current => current || wh);
            }
        } catch (err) {
            console.error('Data Loading Error:', err);
            setWarehouseLoadFailed(true);
        }
    };
    const addClaimsToUser = async (val) => {
        var addClaimObject = {
            UserId: oidc.user.profile.sub,
            Type: "warehouse",
            Value: val,
        };
        axios
            .post(
                `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.addClaim}`,
                addClaimObject,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then((result) => {
            });
    };
const handelValueDateChanged = (e) => {
    setSelectedWarehouse(e.value);
    // e.event is set only for the user's own pick; setting the value from the profile fires this handler too.
    if (e.event) {
        addClaimsToUser(e.value);
    }
};
useEffect(() => {
    fetchWareHouseList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
// Rebuild the PTR address when the page or the warehouse changes. Deliberately not on token renewal,
// which would reload the frame and lose the user's unsaved work in PTR.
useEffect(() => {
    const url = selectedWarehouse ? buildPtrUrl(selectedWarehouse) : '';
    // Only a new address reloads the frame, so only then wait for its onLoad to hide the loading panel.
    if (url !== source) {
        setSource(url);
        setFrameLoading(url !== '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [reportType, selectedWarehouse]);
return (
    <div style={{ width: "100%", height: "100%" }}>
        <div style={{ display: 'flex', marginBottom: '10px' }}>
            <div style={{ flex: 1 }}>
                <SelectBox
                    dataSource={warehouse}
                    displayExpr="name"
                    valueExpr="id"
                    value={selectedWarehouse}
                    labelMode="static"
                    label="warehouse"
                    placeholder="Select a warehouse"
                    onValueChanged={handelValueDateChanged}
                />
            </div>
        </div>
        {source ? (
            <div id="ptrFrameContainer" style={{ height: "90%", width: "100%" }}>
                <LoadPanel
                    visible={frameLoading}
                    position={{ of: '#ptrFrameContainer' }}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    hideOnOutsideClick={false}
                />
                <iframe title="Pull Tag Review" src={source} height="100%" width="100%" style={{ border: "none" }} onLoad={() => setFrameLoading(false)}></iframe>
            </div>
        ) : (
            <div style={{ padding: 16 }}>
                {warehouseLoadFailed ? "The warehouse list could not be loaded." : "Select a warehouse to open this page."}
            </div>
        )}
    </div>
);
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LoadIframe);